import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import { VueReCaptcha } from 'vue-recaptcha-v3'


import './plugins/fontawesome'
import App from './App.vue'

import Index from './pages/Index.vue'
import Cart from './pages/Cart.vue'
import Thanks from './pages/Thanks.vue'

import SummerBlondie from './pages/beers/SummerBlondie.vue'
import LondonCalling from './pages/beers/LondonCalling.vue'
import IceIceHazy from './pages/beers/IceIceHazy.vue'
import Snowitt from './pages/beers/Snowitt'
import Sunset from './pages/beers/Sunset'
import Smash from './pages/beers/Smash'
import Brownie from './pages/beers/Brownie'
import SoberFox from './pages/beers/SoberFox'

import Sales from './pages/other/Sales'

import PageNotFound from './pages/404.vue'

import VueMeta from 'vue-meta'


import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueReCaptcha, { siteKey: '6Lfp5tUZAAAAABIVuv_o58YOaEYkG9wSGEOPM-L8' })

if (window.location.origin.includes("hoppyhedgehog.cz")) {
  Vue.prototype.$apipath = '/beershop'
}else{
  Vue.prototype.$apipath = '/beershop-test'
}

function postData(url = "", reqData = {}) {
  // Default options are marked with *
  return fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic ZGVtbzpkZW1v"
    },
    body: JSON.stringify(reqData) // body data type must match "Content-Type" header
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      return response.text().then(text => { throw new Error("\nHTTP " + response.status + ' - ' + text) });
    }
  });
}

const routes = [
  { path: '/', name: 'index', component: Index },
  { path: '/cart', name: 'cart', component: Cart },
  { path: '/ordered', name: 'thanks', component: Thanks },
  { path: '/obchodnik', name: 'obchodnik', component: Sales },
  // beers
  { path: '/summer-blondie', name: 'summer-blondie', component: SummerBlondie },
  { path: '/london-calling', name: 'london-calling', component: LondonCalling },
  { path: '/ice-ice-hazy', name: 'ice-ice-hazy', component: IceIceHazy },
  { path: '/snowitt', name: 'london-calling', component: Snowitt },
  { path: '/sunset', name: 'sunset', component: Sunset },
  { path: '/smash', name: 'smash', component: Smash },
  { path: '/brownie', name: 'brownie', component: Brownie },
  { path: '/sober-fox', name: 'sober-fox', component: SoberFox },

  { path: "*", component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})


const store = new Vuex.Store({
  state: {
    notifications: [],
    test: 'test',
    cart: [],
    order: {}
  },
  getters: {
    transport: state => {
      var e = state.cart.find(function (element) {
        return element.item.name === "Doprava"
      });
      if (e === undefined) return null;
      else {
        return e.variant.name;
      }
    }
  },
  mutations: {
    fetchCart(state, cart) {
      state.cart = cart
    },
    fetchOrder(state, order) {
      state.order = order
    },
    addNotification(state, notification) {
      state.notifications.push(notification);
    },
    removeNotification(state, notification) {
      state.notifications.splice(state.notifications.indexOf(notification), 1);
    }
  },
  actions: {
    fetchCart({ commit }) {
      fetch(Vue.prototype.$apipath+"/api/cart")
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            return response.text().then(text => { throw new Error("\nHTTP " + response.status + ' - ' + text) });
          }
        })
        .then((response) => {
          commit("fetchCart", response);
        })
        .catch((error) => {
          // Your error is here!
          throw error;
        });
    },



    updateCart({ commit }, cartData) {
      postData(Vue.prototype.$apipath+"/api/cart", cartData).then(
        data => {
          commit("fetchCart", data);
        }
      ).catch((error) => {
        // Your error is here!
        throw error;
      });
    },

    updateTransport({ commit }, transportType) {
      postData(Vue.prototype.$apipath+"/api/cart/transport", transportType).then(
        data => {
          commit("fetchCart", data);
        }
      ).catch((error) => {
        // Your error is here!
        throw error;
      });
    },

    async order({ commit }, order) {
      await postData(Vue.prototype.$apipath+"/api/cart/order", order).then(
        data => {
          commit("fetchCart", data.cartItems);
          commit("fetchOrder", data);
        }
      ).catch((error) => {
        // Your error is here!
        throw error;
      });
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  tagIDKeyName: 'vmid'
}).$mount('#app')
